export default __webpack_public_path__ + "static/PAPC-404-a43265202e080aaf664cd9154ac1408b.jpg";